import { Box, Flex, Spinner, Text } from '@chakra-ui/react'
import React from 'react'

// The card a dashboard widget shows while its query loads or after it failed.
export const WidgetLoading: React.FC = () => (
  <Flex
    bg='app.bg'
    borderWidth='1px'
    borderColor='app.border'
    borderRadius='lg'
    height='340px'
    align='center'
    justify='center'
  >
    <Spinner />
  </Flex>
)

export const WidgetError: React.FC = () => (
  <Box bg='app.bg' borderWidth='1px' borderColor='app.border' borderRadius='lg' p={5}>
    <Text color='red.500'>Could not load this widget.</Text>
  </Box>
)
